export default {
    getSelectedOrg: (state) => {
        return state.selectedOrg;
    },
    getUserOrgs: (state) => {
        return state.orgList
    }
};